<template>
    <breeze-authenticated-layout>
        <template #header>
            <div class="flex space-x-2 items-center">
                <h2 class="font-semibold text-3xl text-gray-800 leading-tight">
                    Dashboard
                </h2>
            </div>

        </template>

        <breeze-page>
            <div class="flex flex-col space-y-6">
                <div class="grid grid-cols-4 gap-6">
                    <FormMultiselect
                        required
                        :options="coursesOptions"
                        track-key="id"
                        label-key="title"
                        return-value="id"
                        v-model="filterForm.course"
                        :placeholder="'Select Course'"
                        @change="(event)=>handleCourse(event)"
                    />
                    <FormMultiselect
                        required
                        :options="courseYears"
                        track-key="id"
                        label-key="title"
                        v-model="filterForm.year"
                        :placeholder="'Select Year'"
                        @change="(event)=>handleFilter('year',event)"
                    />
                    <FormMultiselect
                        required
                        :options="durationsOptions"
                        track-key="id"
                        label-key="title"
                        v-model="filterForm.duration"
                        :placeholder="'Select Duration'"
                        @change="(event)=>handleFilter('duration',event)"
                    />
                    <div>

                        <DatePicker v-model="selectedDateRange"
                                    is-range
                                    :modelConfig="{ type: 'string', mask: 'YYYY-MM-DD' }"
                                    :masks="{ input: 'DD/MM/YYYY' }">
                            <template v-slot="{ inputValue, togglePopover }">
                                <div class="flex items-center relative">
                                    <button
                                        class="p-2 py-2.5 bg-blue-100 border border-r-none border-blue-200 hover:bg-blue-200 text-blue-600 rounded-l focus:bg-blue-500 focus:text-white focus:border-blue-500 focus:outline-none"
                                        @click="togglePopover()"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 20 20"
                                            class="w-4 h-4 fill-current"
                                        >
                                            <path
                                                d="M1 4c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4zm2 2v12h14V6H3zm2-6h2v2H5V0zm8 0h2v2h-2V0zM5 9h2v2H5V9zm0 4h2v2H5v-2zm4-4h2v2H9V9zm0 4h2v2H9v-2zm4-4h2v2h-2V9zm0 4h2v2h-2v-2z"
                                            ></path>
                                        </svg>
                                    </button>

                                    <input
                                        placeholder="Select dates"
                                        :value="inputValue.start&&inputValue.end &&`${inputValue.start??''}-${inputValue.end??''}`"
                                        class="bg-white text-gray-700 w-full py-1.5 px-2 borde-l-0 appearance-none border-gray-300  rounded-r focus:outline-none focus:border-gray-900 border border-l-0"
                                        disabled
                                    />
                                    <Xicon v-if="inputValue.start&&inputValue.end" @click="handleResetDate"
                                           class="h-6 w-6 absolute right-2 cursor-pointer text-red-500 hover:text-red-800"/>
                                </div>
                            </template>
                        </DatePicker>

                    </div>
                </div>

                <div class="flex space-x-6">
                    <div
                        class="relative bg-white w-1/2 h-[400px] p-4 py-10 rounded-md flex justify-center items-center">
                        <h4 class="absolute bottom-2">Collection by Mode of Payment</h4>
                        <button @click="handleExport('paymentMode')"
                                class="absolute top-4 right-4 bg-gray-800 text-white rounded-md text-xs py-1 px-2">
                            Export
                        </button>

                        <Pie :data="paymentCollectionPieData" :options="options"/>
                    </div>
                    <div
                        class="relative bg-white w-1/2 h-[400px] p-4 py-10 rounded-md flex justify-center items-center">
                        <h4 class="absolute bottom-2">Collection by Month</h4>
                        <button @click="handleExport('paymentByMonth')"
                                class="absolute top-4 right-4 bg-gray-800 text-white rounded-md text-xs py-1 px-2">
                            Export
                        </button>

                        <Bar :data="collection_by_month" :options="options"/>
                    </div>
                </div>
                <div class="flex gap-6">
                    <div
                        class="relative bg-white w-full h-[400px] p-4 py-10 rounded-md flex justify-center items-center">
                        <h4 class="absolute bottom-2">Admissions by Courses</h4>
                        <button @click="handleExport('admissionByCourse')"
                                class="absolute top-4 right-4 bg-gray-800 text-white rounded-md text-xs py-1 px-2">
                            Export
                        </button>

                        <Line :data="admission_by_courses" :options="options"/>
                    </div>
                    <div
                        class="relative bg-white w-[500px] h-[400px] p-4 py-10 rounded-md ">
                        <h4 class="absolute bottom-2 justify-center w-full text-center">University Admissions</h4>

                        <div class="w-full grid gap-6">

                            <div
                                class="px-4 py-5 overflow-hidden rounded-lg sm:p-6 bg-gray-50 cursor-default text-center"
                            >
                                <p class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
                                    {{ university.pending }}</p>
                                <p class="text-sm font-medium truncate text-gray-500 mt-1">Pending</p>
                            </div>
                            <div
                                class="px-4 py-5 overflow-hidden rounded-lg sm:p-6 bg-gray-50 cursor-default text-center"
                            >
                                <p class="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
                                    {{ university.approved }}</p>
                                <p class="text-sm font-medium truncate text-gray-500 mt-1">Approved</p>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="flex gap-6">
                    <div
                        class="relative bg-white w-full h-[345px]  p-4 py-10 rounded-md flex ">
                        <h4 class="absolute bottom-2 justify-center w-full text-center">Progress Bar</h4>
                        <button @click="handleExport('progressBar')"
                                class="absolute top-4 right-4 bg-gray-800 text-white rounded-md text-xs py-1 px-2">
                            Export
                        </button>
                        <div class="w-full mt-4">
                            <div class="mb-2 gap-y-6 grid">
                                <ProgressBar v-for="(item,index) in progress_bar_data"
                                             :key="index"
                                             :value="item.value"
                                             :label="item.name"/>
                            </div>
                        </div>
                    </div>
                    <div
                        class="relative bg-white w-[500px] p-4 py-10 rounded-md flex ">
                        <h4 class="absolute bottom-2 justify-center w-full text-center">Job Placements</h4>

                        <button v-if="isShowStudent" @click="isShowStudent=false"
                                class="absolute top-4  left-4 bg-gray-800 text-white rounded-full text-xs p-1">
                            <ChevronLeft class="text-white h-4 w-4"/>
                        </button>
                        <div class="w-full mt-2">
                            <div class="relative h-[250px] overflow-auto">
                                <div class="border">
                                    <table v-if="isShowStudent"
                                           class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                                        <thead class="text-xs text-gray-700 uppercase dark:text-gray-400">
                                        <tr>
                                            <th scope="col" class="px-4 py-3 bg-gray-50 dark:bg-gray-800">
                                                Applied Students
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr class="border-b  border-gray-200 dark:border-gray-700"
                                            v-for="(student,index) in students" :key="index">
                                            <th scope="row"
                                                class="px-4 py-4 font-medium  whitespace-nowrap ">
                                                {{ student.first_name }} {{ student.middle_name }} {{
                                                    student.last_name
                                                }}
                                            </th>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <table v-else
                                           class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                                        <thead class="text-xs text-gray-700 uppercase dark:text-gray-400">
                                        <tr>
                                            <th scope="col" class="px-4 py-3 bg-gray-50 dark:bg-gray-800">
                                                Company name
                                            </th>
                                            <th scope="col" class="px-4 py-3">
                                                No. Of Students
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr class="border-b border-gray-200 dark:border-gray-700 "
                                            v-for="(item,index) in companies" :key="index">
                                            <th scope="row"
                                                class="px-4 py-4 font-medium  whitespace-nowrap bg-gray-50 ">
                                                {{ item.name }}
                                            </th>
                                            <td class="px-4 py-4">
                                                <p class="text-blue-600 hover:underline cursor-pointer" @click="()=>{
                                                isShowStudent=true;
                                                students = item.students;
                                            }">
                                                    {{ item.students_count }}
                                                </p>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                    <div class="flex text-center py-8 w-full justify-center font-medium text-sm text-gray-700" v-if="!companies.length"><p>Companies not
                                        found.</p></div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>

                <div v-if="is_super_admin" class="grid grid-cols-2 gap-6">
                    <div class="col-span-2 flex justify-end">
                        <button @click="handleExport('all_report')"
                                class="bg-gray-800 text-white rounded-md text-xs py-1 px-2">
                            Export All
                        </button>
                    </div>
                    <div
                        class="relative bg-white w-full p-4 py-10 rounded-md flex justify-center items-center">
                        <h4 class="absolute bottom-2">Admissions </h4>
                        <button @click="handleExport('admissionReport')"
                                class="absolute top-4 right-4 bg-gray-800 text-white rounded-md text-xs py-1 px-2">
                            Export
                        </button>
                        <Bar :data="super_admin_bar_data" :options="options"/>
                    </div>
                    <div
                        class="relative bg-white w-full p-4 py-10 rounded-md flex justify-center items-center">
                        <h4 class="absolute bottom-2">Collection </h4>
                        <button @click="handleExport('collectionReport')"
                                class="absolute top-4 right-4 bg-gray-800 text-white rounded-md text-xs py-1 px-2">
                            Export
                        </button>
                        <Bar :data="super_admin_fees" :options="options"/>
                    </div>

                    <div
                        class="relative bg-white w-full p-4 py-10 rounded-md flex justify-center items-center">
                        <h4 class="absolute bottom-2">Ratings </h4>
                        <button @click="handleExport('ratingsReport')"
                                class="absolute top-4 right-4 bg-gray-800 text-white rounded-md text-xs py-1 px-2">
                            Export
                        </button>
                        <Bar :data="super_admin_ratings" :options="options"/>
                    </div>
                    <div
                        class="relative bg-white w-full p-4 py-10 rounded-md flex justify-center items-center">
                        <h4 class="absolute bottom-2">Internal Marking </h4>
                        <button @click="handleExport('internalMarkingReport')"
                                class="absolute top-4 right-4 bg-gray-800 text-white rounded-md text-xs py-1 px-2">
                            Export
                        </button>
                        <Bar :data="super_admin_internal_marking" :options="options"/>
                    </div>
                </div>
            </div>
        </breeze-page>
    </breeze-authenticated-layout>
</template>

<script setup>
import {computed, onMounted, ref, watch} from 'vue';
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated';
import BreezePage from '@/Components/Page';

import {
    ArcElement,
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    LineElement,
    PointElement,
    Title,
    Tooltip
} from 'chart.js';

import {Bar, Line, Pie} from 'vue-chartjs';
import {useForm, usePage} from "@inertiajs/inertia-vue3";
import ProgressBar from "@/Components/ProgressBar.vue";
import ChevronLeft from "@/Components/Icons/ChevronLeft.vue";
import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";
import {getParameters, makeParameter, setPath} from "../../Utils/Common";
import {Inertia} from "@inertiajs/inertia";
import {DatePicker} from "v-calendar";
import Xicon from "@/Components/Icons/Xicon.vue";

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title, LineElement, PointElement);
const parameters = getParameters();
const university = computed(() => usePage().props.value?.university);

const paymentCollectionPieData = computed(() => usePage().props.value?.paymentCollectionPieData);
const admission_by_courses = computed(() => usePage().props.value?.admission_by_courses);
const collection_by_month = computed(() => usePage().props.value?.collection_by_month);
const super_admin_bar_data = computed(() => usePage().props.value?.super_admin_bar_data);

const coursesOptions = computed(() => usePage().props.value?.courses);
const durations = computed(() => usePage().props.value?.durations);
const courseYears = computed(() => usePage().props.value.courseYears);
const progress_bar_data = computed(() => usePage().props.value?.progress_bar_data);
const super_admin_fees = computed(() => usePage().props.value?.super_admin_fees);
const super_admin_ratings = computed(() => usePage().props.value?.super_admin_ratings);
const super_admin_internal_marking = computed(() => usePage().props.value?.super_admin_internal_marking);
const is_super_admin = computed(() => usePage().props.value?.is_super_admin);

const students = ref([]);

const companies = computed(() => {
    let data = [];
    data = usePage().props.value.companies.map((item) => {
        let _students = [];
        item.jobs.map((job) => {
            _students = [..._students, ...job.students]
            return job;
        })
        return {name: item?.name, students_count: _students.length, students: _students,}
    });
    return data;
});

const durationsOptions = computed(() => {
    let data = [];
    durations.value.forEach(item => {
        data.push({
            id: item.id,
            title: item.start_month + " - " + item.end_month
        });
    });
    return data;
});

const yearsOptions = computed(() => {
    let data = [];
    years.value.forEach(item => {
        data.push({id: item.toString(), title: item.toString()});
    });
    return data;
});

const isShowStudent = ref(false);
const selectedDateRange = ref({
    start: parameters.from_date ?? '',
    end: parameters.to_date ?? ''
});

const filterForm = useForm({
    branch: parameters.branch,
    course: parameters.course,
    duration: parameters.duration,
    year: parameters.year,
});

watch(selectedDateRange, (_new, _old) => {
    let query = makeParameter({
        from_date: _new.start,
        to_date: _new.end
    });
    Inertia.visit(`/dashboard${query}`);
});

const options = ref({
    responsive: true,
    maintainAspectRatio: false
});
const handleCourse = (id) => {
    let query = makeParameter({
        course: id,
        year: null
    });
    Inertia.visit(`/dashboard${query}`);
}
const handleResetDate = () => {
    let query = makeParameter({
        from_date: null,
        to_date: null
    });
    Inertia.visit(`/dashboard${query}`);
}

const handleFilter = (name, value) => {
    const query = makeParameter(name, value ?? null);
    Inertia.visit(`/dashboard${query}`);
}

const handleExport = (exportKey = null) => {
    const query = makeParameter('type', exportKey);
    window.open(`${route('dashboard.export')}${query}`)
}

</script>
